import { render, staticRenderFns } from "./UserChallengeCard.vue?vue&type=template&id=33ae4aba&scoped=true&"
import script from "./UserChallengeCard.vue?vue&type=script&lang=js&"
export * from "./UserChallengeCard.vue?vue&type=script&lang=js&"
import style0 from "./UserChallengeCard.vue?vue&type=style&index=0&id=33ae4aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae4aba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
